import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const navItems = [
    { name: 'Accueil', path: '/' },
    { name: 'Billeterie', path: '/billeterie' },
    { name: 'Affrètement', path: '/affretement' },
    { name: 'Voyages', path: '/voyages' },
    { name: 'Événements', path: '/evenements' },
    { name: 'À Propos', path: '/a-propos' },
    { name: 'Contact', path: '/contact' }
  ];

  return (
    <header style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      zIndex: 1000,
      background: 'rgba(255, 255, 255, 0.98)',
      backdropFilter: 'blur(12px)',
      borderBottom: '1px solid var(--border-light)',
      boxShadow: '0 2px 8px rgba(0, 0, 0, 0.04)'
    }}>
      <nav className="container" style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '20px 40px',
        maxWidth: '87.5rem',
        margin: '0 auto'
      }}>
        {/* Logo */}
        <Link to="/" style={{
          textDecoration: 'none',
          display: 'flex',
          alignItems: 'center'
        }}>
          <img 
            src="https://customer-assets.emergentagent.com/job_corporate-concierge/artifacts/42z9uo0n_Agence%20PNG.png"
            alt="L'Agence"
            style={{
              height: '60px',
              width: 'auto'
            }}
          />
        </Link>

        {/* Desktop Navigation */}
        <div style={{
          display: 'flex',
          gap: '10px',
          alignItems: 'center'
        }} className="desktop-nav">
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className="nav-link"
              style={{
                color: location.pathname === item.path ? 'var(--brand-primary)' : 'var(--text-secondary)',
                fontWeight: location.pathname === item.path ? 600 : 500
              }}
            >
              {item.name}
            </Link>
          ))}
        </div>

        {/* Mobile Menu Toggle */}
        <button
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          className="mobile-menu-toggle"
          style={{
            display: 'none',
            background: 'transparent',
            border: 'none',
            color: 'var(--brand-primary)',
            cursor: 'pointer',
            padding: '8px'
          }}
        >
          {mobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
        </button>
      </nav>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="mobile-menu" style={{
          display: 'none',
          background: 'var(--bg-page)',
          borderTop: '1px solid var(--border-medium)',
          padding: '20px'
        }}>
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className="nav-link"
              onClick={() => setMobileMenuOpen(false)}
              style={{
                display: 'block',
                padding: '15px 20px',
                color: location.pathname === item.path ? 'var(--brand-primary)' : 'var(--text-secondary)',
                borderBottom: '1px solid var(--border-light)'
              }}
            >
              {item.name}
            </Link>
          ))}
        </div>
      )}

      <style>{`
        @media (max-width: 768px) {
          .desktop-nav {
            display: none !important;
          }
          .mobile-menu-toggle {
            display: block !important;
          }
          .mobile-menu {
            display: block !important;
          }
        }
      `}</style>
    </header>
  );
};

export default Header;